var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNitroIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fill 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70852 7.97063L4.4735 6.86073V6.86092L4.38359 6.7714L4.38856 6.80765L4.38353 6.77108L4.35128 6.53793L3.98263 3.87492C3.98811 3.88111 3.99404 3.88737 3.99959 3.89298L5.23467 5.00288V5.00262L5.32451 5.09214L5.31955 5.05602L5.32458 5.09253L5.35689 5.32568L5.72548 7.98869C5.72 7.98249 5.71413 7.97617 5.70852 7.97063ZM8.53663 0.868737L5.37443 0.0264292C4.94522 -0.0878563 4.64512 0.179283 4.70626 0.619656L5.18733 4.10027L5.16805 4.07628L5.1634 4.07021L3.72871 2.52407C3.72568 2.52065 3.72335 2.5184 3.72116 2.51543C3.59043 2.35561 3.37547 2.3718 3.15728 2.59192L1.88234 3.87589C1.56941 4.19088 1.26106 4.80856 1.19753 5.24867L0.50859 9.98739C0.444805 10.4271 0.743224 10.8802 1.17154 10.9949L4.33367 11.8372C4.76289 11.9515 5.06298 11.6844 5.00184 11.244L4.52071 7.76334L4.54006 7.78733L4.5447 7.79333L5.9794 9.33947C5.98243 9.34296 5.98475 9.34521 5.98694 9.34812C6.11768 9.50794 6.33264 9.49175 6.55089 9.27169L7.82577 7.98772C8.1387 7.67266 8.44705 7.05499 8.51058 6.61487L9.19951 1.87622C9.2633 1.43655 8.96488 0.983474 8.53663 0.868737Z",
    fill: "#F54811"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNitroIcon);
export default __webpack_public_path__ + "static/media/nitro-icon.53541c98573833ccbd35778dda0c7877.svg";
export { ForwardRef as ReactComponent };